import React, { useContext } from 'react';

import CardControlContext from '@/context/card-control/CardControlContext';

import SelectedCategory from './selected-category/SelectedCategory';
import Settings from './settings/Settings';

import './CardControl.scss';

export const CardControl = () => {
    const { selectedCategory } = useContext(CardControlContext);

    return <section className="card-control">{selectedCategory ? <SelectedCategory /> : <Settings />}</section>;
};
